import { Container, Group, Text, Anchor, Divider, Box, Stack } from "@mantine/core";
// @ts-ignore
const CURRENT_YEAR = new Date().getFullYear();
import { IconBrandX, IconBrandTelegram, IconExternalLink } from "@tabler/icons-react";
import { Link } from "gatsby";
import React from "react";

const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Projects", to: "/projects/" },
  { label: "HUB", to: "/hub/" },
  { label: "Blog", to: "/blog/" },
  { label: "YD", to: "/yd/" },
];

const PRODUCT_LINKS = [
  { label: "PotBot App", href: "https://potbot.fun" },
  { label: "PotBot v2", to: "/projects/potbot-v2/" },
];

const linkStyle = { color: "var(--mantine-color-dimmed)", fontSize: 14, textDecoration: "none" };

const Footer: React.FC = () => (
  <Box
    component="footer"
    style={{
      marginTop: 60,
      borderTop: "1px solid rgba(153, 69, 255, 0.18)",
      background: "rgba(255,255,255,0.015)",
      paddingTop: 40,
    }}
  >
    <Container size="lg" px="md">
      <Group justify="space-between" align="flex-start" wrap="wrap" gap={36} mb={32}>
        <Box style={{ maxWidth: 280 }}>
          <Text
            fw={900}
            style={{
              background: "linear-gradient(45deg, #9945FF, #14F195)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontSize: "1.5rem",
              letterSpacing: "-0.5px",
            }}
          >
            Y-DAO
          </Text>
          <Text size="xs" c="dimmed" mt={6} style={{ lineHeight: 1.5 }}>
            A founder-led, coordinated collective building products, dealflow, and network on Solana.
          </Text>
        </Box>

        <Stack gap="xs">
          <Text tt="uppercase" fz="xs" fw={800} c="dimmed">Navigate</Text>
          {NAV_LINKS.map((link) => (
            <Anchor key={link.label} component={Link} to={link.to} style={linkStyle}>
              {link.label}
            </Anchor>
          ))}
        </Stack>

        <Stack gap="xs">
          <Text tt="uppercase" fz="xs" fw={800} c="dimmed">Products</Text>
          {PRODUCT_LINKS.map((link) => link.href ? (
            <Anchor key={link.label} href={link.href} target="_blank" rel="noopener noreferrer" style={{ ...linkStyle, display: "inline-flex", alignItems: "center", gap: 4 }}>
              {link.label} <IconExternalLink size={13} />
            </Anchor>
          ) : (
            <Anchor key={link.label} component={Link} to={link.to!} style={linkStyle}>
              {link.label}
            </Anchor>
          ))}
        </Stack>

        <Stack gap="xs">
          <Text tt="uppercase" fz="xs" fw={800} c="dimmed">Social</Text>
          <Anchor
            href="https://x.com/CryptoYDao"
            target="_blank"
            rel="noopener noreferrer"
            style={{ ...linkStyle, display: "flex", alignItems: "center", gap: 8 }}
          >
            <IconBrandX size={18} stroke={1.5} /> @CryptoYDao
          </Anchor>
          <Anchor
            href="https://t.me/YegorDO"
            target="_blank"
            rel="noopener noreferrer"
            style={{ ...linkStyle, display: "flex", alignItems: "center", gap: 8 }}
          >
            <IconBrandTelegram size={18} stroke={1.5} /> Telegram
          </Anchor>
        </Stack>
      </Group>

      <Divider style={{ borderColor: "rgba(153, 69, 255, 0.1)" }} />

      <Text ta="center" size="xs" c="dimmed" py={20} style={{ fontFamily: "IBM Plex Mono, monospace" }}>
        © {CURRENT_YEAR} Y-DAO. Built on Solana.{" "}
        <Anchor component={Link} to="/manifesto/" style={{ color: "var(--mantine-color-dimmed)", textDecoration: "none" }}>
          Manifesto →
        </Anchor>
      </Text>
    </Container>
  </Box>
);

export default Footer;
